// extracted by mini-css-extract-plugin
module.exports = {"meta":"meta___30XnF","card":"card___3Us0t","prev":"prev___BeHrH","text":"text___hK37G","authorDes":"authorDes___26-BL"};